export class ScoreConfig {
    public static scoreTabl = {
        '3': {
            simple: {
                score: 100,
                progress: 7
            },
            auto: {
                score: 150,
                progress: 9
            }
        },
        '4': {
            simple: {
                score: 200,
                progress: 9
            },
            auto: {
                score: 250,
                progress: 11
            }
        },
        '5': {
            simple: {
                score: 300,
                progress: 11
            },
            auto: {
                score: 350,
                progress: 13
            }
        },
        '6': {
            simple: {
                score: 400,
                progress: 13
            },
            auto: {
                score: 450,
                progress: 15
            }
        },
        '7': {
            simple: {
                score: 500,
                progress: 15
            },
            auto: {
                score: 550,
                progress: 17
            }
        }
    }
}